module.exports = __webpack_public_path__ + "static/404-92d475162e21148125a380f6e25f0fa5.svg";